// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationSaveCurrentUserDefaultResponse {
    static getAttributeTypeMap() {
        return AuthenticationSaveCurrentUserDefaultResponse.attributeTypeMap;
    }
}
AuthenticationSaveCurrentUserDefaultResponse.discriminator = undefined;
AuthenticationSaveCurrentUserDefaultResponse.additionalProperties = false;
AuthenticationSaveCurrentUserDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "string"
    },
];
//# sourceMappingURL=authenticationSaveCurrentUserDefaultResponse.js.map